/* ==========================================================================
   Gifty PH — Custom JavaScript
   Progress indicator, ATC validation, ReelUp lazy-load
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. Globo Form Progress Indicator + ATC State
     ------------------------------------------------------------------ */
  function initProgressBar() {
    // Find Globo's form container — try multiple selectors
    var globoForm = document.querySelector(
      '.globo-product-options, .globo__product-options, [class*="globo-po"], [id*="globo"]'
    );
    if (!globoForm) {
      // Globo might load late — retry for up to 10 seconds
      if (initProgressBar._retries < 20) {
        initProgressBar._retries = (initProgressBar._retries || 0) + 1;
        setTimeout(initProgressBar, 500);
      }
      return;
    }

    // Create progress bar element
    var progressBar = document.createElement('div');
    progressBar.className = 'gifty-progress-bar';
    progressBar.innerHTML =
      '<div class="gifty-progress-bar__label">' +
      '<span class="gifty-progress-bar__text">Fill in your song details</span>' +
      '<span class="gifty-progress-bar__count">0 / 0</span>' +
      '</div>' +
      '<div class="gifty-progress-bar__track">' +
      '<div class="gifty-progress-bar__fill"></div>' +
      '</div>';

    // Insert before the Globo form
    globoForm.parentNode.insertBefore(progressBar, globoForm);

    var fill = progressBar.querySelector('.gifty-progress-bar__fill');
    var countLabel = progressBar.querySelector('.gifty-progress-bar__count');
    var textLabel = progressBar.querySelector('.gifty-progress-bar__text');

    function getRequiredFields() {
      // Get all form fields inside Globo
      var fields = globoForm.querySelectorAll(
        'input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea'
      );
      var visible = [];
      fields.forEach(function (f) {
        // Only count visible fields
        if (f.offsetParent !== null || f.offsetHeight > 0) {
          visible.push(f);
        }
      });
      return visible;
    }

    function isFieldFilled(field) {
      if (field.tagName === 'SELECT') {
        return field.value && field.selectedIndex > 0;
      }
      if (field.type === 'checkbox' || field.type === 'radio') {
        // For radio/checkbox groups, check if any in the group is checked
        if (field.name) {
          var group = globoForm.querySelectorAll('[name="' + field.name + '"]');
          for (var i = 0; i < group.length; i++) {
            if (group[i].checked) return true;
          }
          return false;
        }
        return field.checked;
      }
      return field.value && field.value.trim() !== '';
    }

    function updateProgress() {
      var fields = getRequiredFields();
      // Deduplicate radio/checkbox groups by name
      var seen = {};
      var uniqueFields = [];
      fields.forEach(function (f) {
        var key = (f.type === 'radio' || f.type === 'checkbox') && f.name ? f.name : f;
        if (!seen[key]) {
          seen[key] = true;
          uniqueFields.push(f);
        }
      });

      var total = uniqueFields.length || 1;
      var filledCount = 0;
      uniqueFields.forEach(function (f) {
        if (isFieldFilled(f)) filledCount++;
      });

      var pct = Math.round((filledCount / total) * 100);

      fill.style.width = pct + '%';
      countLabel.textContent = filledCount + ' / ' + total;

      if (pct === 100) {
        textLabel.textContent = 'All details filled!';
      } else if (pct > 50) {
        textLabel.textContent = 'Almost there...';
      } else {
        textLabel.textContent = 'Fill in your song details';
      }

      // ATC button stays pink always — Globo handles its own validation
    }

    // Observe DOM changes (Globo reveals fields dynamically)
    var observer = new MutationObserver(function () {
      setTimeout(updateProgress, 100);
    });

    observer.observe(globoForm, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'value', 'checked']
    });

    // Listen for all input events
    globoForm.addEventListener('input', updateProgress);
    globoForm.addEventListener('change', updateProgress);
    globoForm.addEventListener('click', function () {
      setTimeout(updateProgress, 150);
    });

    // Initial check
    setTimeout(updateProgress, 300);
  }
  initProgressBar._retries = 0;

  /* ------------------------------------------------------------------
     2. ReelUp Lazy Loading via IntersectionObserver
     ------------------------------------------------------------------ */
  function initLazyReelUp() {
    var reelupSections = document.querySelectorAll(
      '[class*="reelup"], [data-reelup], .shopify-app-block [class*="reel"]'
    );
    if (!reelupSections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('gifty-reelup-visible');
            var iframes = entry.target.querySelectorAll('iframe[data-src]');
            iframes.forEach(function (iframe) {
              iframe.src = iframe.dataset.src;
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px' }
    );

    reelupSections.forEach(function (section) {
      observer.observe(section);
    });
  }

  /* ------------------------------------------------------------------
     3. CTA scroll + focus (GW-014/GW-015)

     Every ".js-start-song" trigger (sticky bar, PDP sub-CTAs) shares one
     behavior: if the form is already on the current page, smooth-scroll to
     it and focus the field Globo is currently showing. If it isn't (a
     visitor on the homepage, cart, a blog post, etc.), do nothing and let
     the link's own href navigate there normally -- every such href already
     ends in #gifty-start, so arriving on the PDP lands on the form on its
     own via the browser's native anchor handling.

     "The field Globo is currently showing" rather than a hardcoded field
     ID: the PDP's own copy says questions load one at a time, so the first
     visible .gpo-input IS the first incomplete one without needing to
     track which fields are already filled.
     ------------------------------------------------------------------ */
  function firstVisibleGpoField() {
    var fields = document.querySelectorAll('.gpo-input');
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].offsetParent !== null) return fields[i];
    }
    return null;
  }

  function firstUnansweredSongField() {
    var scope = document.getElementById('gifty-song-form') ||
      document.querySelector('.product__info-container') || document;
    var fields = scope.querySelectorAll('.gpo-input, #gsf-form input, #gsf-form select, #gsf-form textarea');
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (!field.matches('input, select, textarea')) field = field.querySelector('input, select, textarea');
      if (!field || field.disabled || field.type === 'hidden' || field.offsetParent === null) continue;
      if (field.type === 'radio') {
        var answered = Array.from(scope.querySelectorAll('input[type="radio"]')).some(function (radio) {
          return radio.name === field.name && radio.checked;
        });
        if (!answered) return field;
      } else if (field.type === 'checkbox') {
        if (field.required && !field.checked) return field;
      } else if (!String(field.value || '').trim()) return field;
    }
    return firstVisibleGpoField();
  }

  // Geometry is checked on scroll and after Globo's asynchronous rendering.
  // Observing the whole form avoids hiding only for one field in a long form.
  function initStickySongVisibility() {
    var bar = document.querySelector('.gifty-sticky');
    var start = document.getElementById('gifty-start');
    var nativeForm = document.getElementById('gifty-song-form');
    if (!bar || (!start && !nativeForm)) return;
    var pending = false;
    function inView(el, height) {
      if (!el || !el.getClientRects().length) return false;
      var rect = el.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < height;
    }
    function update() {
      pending = false;
      var height = Math.min(window.innerHeight, window.visualViewport ? window.visualViewport.height : window.innerHeight);
      var hero = document.querySelector('.product__title') || start || nativeForm;
      var forms = document.querySelectorAll('#gifty-song-form, .product__info-container product-form, .globo-product-options, .globo__product-options');
      var buttons = document.querySelectorAll('.product-form__submit, #gsf-submit');
      var obscuresForm = inView(start, height) || Array.from(forms).concat(Array.from(buttons)).some(function (el) {
        return inView(el, height);
      });
      bar.hidden = hero.getBoundingClientRect().bottom > 0 || obscuresForm;
    }
    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
    var main = document.getElementById('MainContent');
    if (main && window.MutationObserver) {
      new MutationObserver(schedule).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    }
  }

  function initStartSongTriggers() {
    var triggers = document.querySelectorAll('.js-start-song');
    if (!triggers.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        // Recorded on every click, including cross-page navigation to the
        // PDP, so gifty-analytics.js's song_form_started event can attribute
        // which CTA actually brought the visitor to the form (GW-017).
        try {
          sessionStorage.setItem('gifty_entry_source', trigger.dataset.entrySource || 'unknown');
        } catch (e) {
          /* sessionStorage unavailable (private mode etc) -- entry_source falls back to 'direct' */
        }

        var target = document.getElementById('gifty-start');
        if (!target) return;

        event.preventDefault();
        var isSticky = trigger.dataset.entrySource === 'sticky_bar';
        var field = isSticky ? firstUnansweredSongField() : firstVisibleGpoField();
        var destination = isSticky && field ? field : target;
        destination.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: isSticky ? 'center' : 'start' });

        window.setTimeout(
          function () {
            if (field) field.focus({ preventScroll: true });
          },
          reduceMotion ? 50 : 450
        );
      });
    });
  }

  /* ------------------------------------------------------------------
     4. Initialize on DOM Ready
     ------------------------------------------------------------------ */
  function init() {
    initProgressBar();
    initLazyReelUp();
    initStartSongTriggers();
    initStickySongVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
